'use client';

import {
  TranslationsKeys,
  TranslationsObject
} from '@codeware/app-cms/util/i18n';
import { SocialIcon, getSocialIconName } from '@codeware/shared/ui/primitives';
import type { SocialMediaBlockSocial } from '@codeware/shared/util/payload-types';
import {
  type RowLabelProps,
  useRowLabel,
  useTranslation
} from '@payloadcms/ui';

/**
 * Custom array row label for social media block platforms array field.
 *
 * Displays the social media icon and platform name instead of the default row number.
 */
export const SocialMediaBlockArrayRowLabel: React.FC<RowLabelProps> = () => {
  const { data, rowNumber } = useRowLabel<SocialMediaBlockSocial>();
  const { t } = useTranslation<TranslationsObject, TranslationsKeys>();
  const { platform } = data ?? {};

  if (platform) {
    return (
      <div className="flex items-center gap-2">
        <SocialIcon platform={platform} />
        <span className="text-muted-foreground">
          {getSocialIconName(platform)}
        </span>
      </div>
    );
  }

  return t('collection:socialMediaWithSuffix', {
    suffix: String(rowNumber).padStart(2, '0')
  });
};

export default SocialMediaBlockArrayRowLabel;
